import { useMutation, useQueryClient } from "@tanstack/react-query";

import { useDomainServices } from "@/providers/DomainServices/DomainServicesContext";

import { sessionQueryKeys } from "./sessionQueryKeys";

export interface UseDeleteSessionVariables {
  sessionId: string;
  /** Required when the caller belongs to more than one org. */
  resourceOwnerId: string;
}

export function useDeleteSession() {
  const { sessionService } = useDomainServices();
  const queryClient = useQueryClient();

  return useMutation<void, Error, UseDeleteSessionVariables>({
    mutationFn: ({ sessionId, resourceOwnerId }) =>
      sessionService.deleteSession(sessionId, { resourceOwnerId }),
    onSuccess: (_void, { sessionId }) => {
      // `removeQueries` is prefix-match by default — because
      // `sessionQueryKeys.topics(id)` and `files(id)` nest under
      // `detail(id)`, a single removeQueries clears detail + topics +
      // files in one call.
      queryClient.removeQueries({
        queryKey: sessionQueryKeys.detail(sessionId),
      });
      void queryClient.invalidateQueries({
        queryKey: sessionQueryKeys.lists(),
      });
    },
  });
}
